/*!
 * @pixi/filter-noise - v7.0.0-alpha
 * Compiled Fri, 09 Sep 2022 16:09:18 UTC
 *
 * @pixi/filter-noise is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */import{Filter as r,defaultFilterVertex as n}from"@pixi/core";var i=`precision highp float;

varying vec2 vTextureCoord;
varying vec4 vColor;

uniform float uNoise;
uniform float uSeed;
uniform sampler2D uSampler;

float rand(vec2 co)
{
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main()
{
    vec4 color = texture2D(uSampler, vTextureCoord);
    float randomValue = rand(gl_FragCoord.xy * uSeed);
    float diff = (randomValue - 0.5) * uNoise;

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (color.a > 0.0) {
        color.rgb /= color.a;
    }

    color.r += diff;
    color.g += diff;
    color.b += diff;

    // Premultiply alpha again.
    color.rgb *= color.a;

    gl_FragColor = color;
}
`;class t extends r{constructor(o=.5,e=Math.random()){super(n,i,{uNoise:0,uSeed:0}),this.noise=o,this.seed=e}get noise(){return this.uniforms.uNoise}set noise(o){this.uniforms.uNoise=o}get seed(){return this.uniforms.uSeed}set seed(o){this.uniforms.uSeed=o}}export{t as NoiseFilter};
//# sourceMappingURL=filter-noise.min.mjs.map
